
import carrot from './images/carrot.jpg'
import peas from './images/vitamin b1.jpg'
import milk from './images/vitamin b2.jpg'
import cereal from './images/vitamin-b3.jpg'
import yolk from './images/vitamin-b5.jpg'
import nuts from './images/vitamin-b6.jpg'
import mussel from './images/vitamin-b12.jpg'
import pepper from './images/vitamin-c.jpg'
import salmon from './images/vitamin-d.jpg'
import oil from './images/vitamin-e.jpg'
import spinach from './images/vitamin-k.jpg'
import calcium from './images/calcium.jpg'
import beans from './images/folic-acid.jpg'
import iron from './images/iron.jpg'
import parsley from './images/manganese.jpg'
import datils from './images/datils.jpg'
import parmesan from './images/parmesan.jpg'
import banana from './images/banana.jpg'
import pistacho from './images/selenium.jpg'
import caviar from './images/sodium.jpg'
import ribes from './images/zinc.jpg'




export const nutrients=  [
    {
        id: 1,
        name: 'Vitamin A',
        image: carrot
    },
    {
        id: 2,
        name: 'Vitamin B1',
        image: peas,
    }, 
    {
        id: 3,
        name: 'Vitamin B2',
        image: milk
    },
    {
        id: 4,
        name: 'Vitamin B3',
        image:  cereal
    },
    {
        id: 5,
        name: 'Vitamin B5',
        image: yolk
    },
    {
        id: 6,
        name: 'Vitamin B6',
        image:  nuts
    },
    {
        id: 7,
        name: 'Vitamin B12',
        image: mussel
    },
    {
        id: 8,
        name: 'Vitamin C',
        image: pepper
    },
    
    {
        id: 9,
        name: 'Vitamin D',
        image: salmon
    },
    {
        id: 10,
        name: 'Vitamin E',
        image: oil
    },
    {
        id: 11,
        name: 'Vitamin K',
        image: spinach
    },
    {
        id: 12,
        name: 'Calcium',
        image: calcium
    },
    {
        id: 13,
        name: 'Folic Acid',
        image: beans
    },
    {
        id: 14,
        name: 'Iron',
        image: iron
    },
    {
        id: 15,
        name: 'Manganese',
        image: parsley
    },
    {
        id: 16,
        name: 'Magnesium',
        image: datils
    },
    {
        id: 17,
        name: 'Phosphorus',
        image: parmesan
    },
    {
        id: 18,
        name: 'Potassium',
        image: banana
    },
    {
        id: 19,
        name: 'Selenium',
        image: pistacho
    },
    {
        id: 20,
        name: 'Sodium',
        image: caviar
    },
    {
        id: 21,
        name: 'Zinc',
        image: ribes
    }

]
export default nutrients